import React from 'react';
import { HeaderHelmet } from '../../components/helmet/helmet';

const Developers = () => {
    return (
        <>
            <HeaderHelmet
                pageName="OpenResume API"
                ogImage="https://marble-landing-site-assets.s3.eu-west-2.amazonaws.com/resume.png"
                ogTitle="OpenResume: The next generation resume"
                ogURL="https://openresume.info/api"
            />
            <p>This is the documentation page</p>
        </>

    )
}

export default Developers;
